export default function SeverityBadge({ value }) {
  if (!value) {
    return <span className="badge badge--neutral">unknown</span>;
  }
  const cls = ['critical', 'high', 'medium', 'low'].includes(value)
    ? `badge badge--${value}`
    : 'badge badge--neutral';
  return <span className={cls}>{value}</span>;
}
